export const FOLDERS_GET_REQUEST = "FOLDERS_GET_REQUEST";
export const FOLDERS_GET_RECEIVE = "FOLDERS_GET_RECEIVE";
export const FOLDERS_ERROR = "FOLDERS_ERROR";

export const FOLDER_SET_MEMBER_REQUEST = "FOLDER_SET_MEMBER_REQUEST";
export const FOLDER_SET_MEMBER_RECEIVE = "FOLDER_SET_MEMBER_RECEIVE";
export const FOLDER_SET_MEMBER_ERROR = "FOLDER_SET_MEMBER_ERROR";
